export default __webpack_public_path__ + "static/media/backup-generator-icon.015d262e.svg";